import { ICourse, IUser } from '@sdk/contracts';
import { useMemo } from 'react';

import { useStudentSubscriptions } from '@/store/students';

export const useAllCoursesForStudent = (profile: IUser) => {
  const { subscriptions, isLoading } = useStudentSubscriptions(profile?._id);

  const courses = useMemo(() => {
    if (!subscriptions || !profile?._id) return [];
    const visibleCourses = subscriptions
      .filter(sub => !sub.isHidden)
      .map(sub => sub.course)
      .filter(Boolean);
    const uniqueById = new Map<string, ICourse>();
    visibleCourses.forEach(c => uniqueById.set(c._id, c));
    return Array.from(uniqueById.values());
  }, [subscriptions, profile?._id]);

  return {
    courses,
    isLoading
  };
};
